import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import ServiceImportTemplate from '../../../components/5templates/ServiceImportTemplate'
import {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import {
    getItemFromSessionStorage,
    removeAllItemsInSessionStorage,
    setItemToSessionStorage
} from '../../../services/util/sessionStorageManager'
import {
    contactListFormatter,
    formatExistingServiceSearch, areAllObjectValuesEmpty,
    serviceListFormatter
} from '../../../services/util/miscellaneousService'
import ApiService from '../../../common/ApiCalls'
import ErrorSnackbar from '../../../components/2compounds/ErrorSnackbar'
import {FeedbackSnackbar} from '../../../components/1elements'
import {validateApproverName} from '../../../services/util/editChecks'
import LoaderBackdrop from '../../../components/2compounds/LoaderBackdrop'

const ImportServiceForm = () => {
    const navigate = useNavigate()
    const [serviceList, setServiceList] = useState({})
    const [selectedServiceType, setSelectedServiceType] = useState('')
    const [selectedServiceTypeId, setSelectedServiceTypeId] = useState('')
    const [searchKeyword, setSearchKeyword] = useState('')
    const [options, setOptions] = useState([])
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
    const [snackbar, setSnackbar] = useState({isOpen: false, severity: "", message: "Information is successfully saved!"})
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [approver, setApprover] = useState(null)
    const [showError, setShowError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const onSave = () => {
        setItemToSessionStorage('selectedServiceList', serviceList)
        if(!validateApproverName(approver)){
            setIsModalOpen(false)
            setIsLoading(true)
            const newLocation = getItemFromSessionStorage('newLocation')
            let formattedNewLocation = {...newLocation}
            const {'account_id': accountId, 'end_customer_id': endCustomerId} = getItemFromSessionStorage('selectedClient')
            const {existingContacts, newContacts} = contactListFormatter(getItemFromSessionStorage('newContact'))
            const selectedServiceList = getItemFromSessionStorage('selectedServiceList')
            const initiatorId = localStorage.getItem('userId')
            const initiatorEmail = localStorage.getItem('email')
            const pendingDataId = getItemFromSessionStorage('pendingDataId')

            const data = {
                pendingDataId: pendingDataId ? pendingDataId : '',
                initiatorId,
                initiatorEmail,
                approverId: approver['user_id'],
                accountId,
                endCustomerId,
                newLocation: formattedNewLocation,
                existingContacts,
                newContacts,
                selectedServiceList: serviceListFormatter(selectedServiceList)
            }

            ApiService().addNewLocationToExistingClient(data)
                .then((res)=>{
                    if(res.error){
                        setSnackbar({severity: 'fail', isOpen: true,
                            message: 'We could not find the address on the map. Please input correct address'})
                    }else{
                        const data = {email: approver.email, name: approver.username}
                        ApiService().notifyApprover(data)
                            .then(()=>{
                                setLoaded(true)
                                setSnackbar({message: "Information is successfully saved!", severity: 'success', isOpen: true})
                                window.setTimeout(()=>{
                                    onCancel()
                                }, 2000)
                            })
                            .catch((err)=>{
                                console.log(err)
                            })
                    }
                })
                .catch((err)=>{
                    console.log(err)
                    setSnackbar( {message: "There was an error!", severity: 'fail', isOpen: true})

                })
        }else{
            setShowError(true)
        }
    }
    const onCancel = () => {
        removeAllItemsInSessionStorage()
        navigate('/adminDashboard')
    }
    const onNext = () => {
        if(!areAllObjectValuesEmpty(serviceList)){
            setIsModalOpen(true)
        }else{
            setIsSnackbarOpen(true)
        }
    }
    const onPrev = () => {
        setItemToSessionStorage('selectedServiceList', serviceList)
        navigate('/addLocation/people')
    }

    useEffect(()=> {
        if(searchKeyword.length){
            const data = {
                name: searchKeyword,
                typeId: selectedServiceTypeId
            }

            ApiService().getServiceByNameAndType(data)
                .then((res)=>{
                    const formattedSearchResult = formatExistingServiceSearch(res)
                    setOptions(formattedSearchResult)
                })
                .catch((err)=>{
                    console.log(err)
                })
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [searchKeyword])

    useEffect(()=>{
        setOptions([])
    }, [selectedServiceType])

    useEffect(()=>{
        const selectedServiceListFromStorage = getItemFromSessionStorage('selectedServiceList')
        if(selectedServiceListFromStorage){
            setServiceList(selectedServiceListFromStorage)
        }
    }, [])

    return (
        <DataImportFormTabs flow={'addLocation'}>
            <ServiceImportTemplate serviceList={serviceList} setServiceList={setServiceList}
                                   onSave={onSave} onNext={onNext} onPrev={onPrev} options={options} selectedServiceType={selectedServiceType}
                                   setSelectedServiceType={setSelectedServiceType} setSelectedServiceTypeId={setSelectedServiceTypeId}
                                   setSearchKeyword={setSearchKeyword} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}
                                   approver={approver} setApprover={setApprover} setFormCheckSnackbar={setIsSnackbarOpen}
                                   formCheckSnackbar={isSnackbarOpen} showError={showError}/>
            <ErrorSnackbar setIsSnackbarOpen={setIsSnackbarOpen} isSnackbarOpen={isSnackbarOpen} message={'Attach at least one service'} />
            <FeedbackSnackbar setSnackbar={setSnackbar} snackbar={snackbar} />
            <LoaderBackdrop open={isLoading} loaded={loaded} />
        </DataImportFormTabs>
    )
}

export default ImportServiceForm
